import type { BnbSettingsType } from "../reducers/BnbSettingsReducer";

export const BNB_SETTINGS_INIT = "bnbSettings/init";
export const BNB_SETTINGS_ENABLE_BUY = "bnbSettings/enableBuy";
export const BNB_SETTINGS_ENABLE_RESERVE = "bnbSettings/enableReserve";
export const BNB_SETTINGS_ENABLE_LEASE = "bnbSettings/enableLease";
export const BNB_SETTINGS_MODEL_HAS_FILTERS = "bnbSettings/modelHasFilters";

type InitBnbSettings = {
    type: typeof BNB_SETTINGS_INIT;
    initState: BnbSettingsType;
};
type EnableBuyType = { type: typeof BNB_SETTINGS_ENABLE_BUY; enable: boolean };
type EnableReserveType = { type: typeof BNB_SETTINGS_ENABLE_RESERVE; enable: boolean };
type EnableLeaseType = { type: typeof BNB_SETTINGS_ENABLE_LEASE; enable: boolean };
export const initBnbSettings = (initState: BnbSettingsType): InitBnbSettings => ({
    type: BNB_SETTINGS_INIT,
    initState,
});

export const BNB_SETTINGS_SET_PAGE_MONTHLY_RATE = "bnbSettings/setPageMonthlyRate";
type SetPageRate = { type: typeof BNB_SETTINGS_SET_PAGE_MONTHLY_RATE; showPageMonthlyRate: boolean };
export const setShowPageMonthlyRate = (show: boolean): SetPageRate => ({
    type: BNB_SETTINGS_SET_PAGE_MONTHLY_RATE,
    showPageMonthlyRate: show,
});

type ModelHasActiveFiltersType = { type: typeof BNB_SETTINGS_MODEL_HAS_FILTERS; activeFilters: boolean };
export const setModelHasActiveFilters = (activeFilters: boolean): ModelHasActiveFiltersType => ({
    type: BNB_SETTINGS_MODEL_HAS_FILTERS,
    activeFilters,
});

export const setEnableBuy = (enable: boolean): EnableBuyType => ({ type: BNB_SETTINGS_ENABLE_BUY, enable });
export const setEnableReserve = (enable: boolean): EnableReserveType => ({
    type: BNB_SETTINGS_ENABLE_RESERVE,
    enable,
});
export const setEnableLease = (enable: boolean): EnableLeaseType => ({
    type: BNB_SETTINGS_ENABLE_LEASE,
    enable,
});

export type BnbSettingsActionsType =
    | InitBnbSettings
    | SetPageRate
    | ModelHasActiveFiltersType
    | EnableBuyType
    | EnableReserveType
    | EnableLeaseType;
